import _objectSpread from "/home/gawron/psrp_wyzwanie/wyzwanie_psrp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/gawron/psrp_wyzwanie/wyzwanie_psrp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { createPathComponent } from '@react-leaflet/core';
import { Polygon as LeafletPolygon } from 'leaflet';
export var Polygon = createPathComponent(function createPolygon(_ref, ctx) {
  var positions = _ref.positions,
      options = _objectWithoutProperties(_ref, ["positions"]);

  var instance = new LeafletPolygon(positions, options);
  return {
    instance: instance,
    context: _objectSpread(_objectSpread({}, ctx), {}, {
      overlayContainer: instance
    })
  };
}, function updatePolygon(layer, props, prevProps) {
  if (props.positions !== prevProps.positions) {
    layer.setLatLngs(props.positions);
  }
});